export const CHANGE_SUBJECT_INFO = 'labroomexperiment/CHANGE_SUBJECT_INFO';
export const CHANGE_ATTACHMENT_LIST = 'labroomexperiment/CHANGE_ATTACHMENT_LIST';
export const CHANGE_LAB_CONTENT = 'labroomexperiment/CHANGE_LAB_CONTENT';
export const CHANGE_GRADE_TPL = 'labroomexperiment/CHANGE_GRADE_TPL'; 
export const CHANGE_MY_SUB_RECORD = 'labroomexperiment/CHANGE_MY_SUB_RECORD';
export const CHANGE_MY_SCORE = 'labroomexperiment/CHANGE_MY_SCORE'; 
export const CHANGE_MY_RECORD_CONTENT = 'labroomexperiment/CHANGE_MY_RECORD_CONTENT'; 
export const CHANGE_RECORD_ALL = 'labroomexperiment/CHANGE_RECORD_ALL';







